// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2CH7k","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1EYIl"};